import React from 'react'
import { Spinner } from '@/components/ui-compat'

const Loader = () => (
  <div
    className="flex"
    style={{
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      padding: '7% 0 0',
    }}
  >
    <Spinner color="primary" style={{ zIndex: 999 }} />
  </div>
)

export default Loader
